import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './DropdownMenu.css';

/**
 * DropdownMenu supports clickable items and optional submenus.
 * Items with `children` toggle nested menus.
 * Items with `path` navigate programmatically without link styles.
 * Items with `onClick` call the custom handler (used e.g. for landing).
 */
const DropdownMenu = ({ items }) => {
  const [openIdx, setOpenIdx] = useState(null);
  const navigate = useNavigate();

  const handleClick = (item, idx) => {
    if (item.onClick) {
      item.onClick();
      setOpenIdx(null);
    } else if (Array.isArray(item.children)) {
      setOpenIdx(openIdx === idx ? null : idx);
    } else if (item.path) {
      navigate(item.path);
      setOpenIdx(null);
    }
  };

  return (
    <div className="dropdown-container">
      {items.map((item, idx) => {
        const hasChildren = Array.isArray(item.children);
        const label = item.label;

        return (
          <div key={idx} className="dropdown-block">
            <ul className="dropdown-submenu">
              <li
                className="dropdown-submenu__item no-uppercase"
                onClick={() => handleClick(item, idx)}
              >
                {label}
              </li>
            </ul>

            {hasChildren && openIdx === idx && (
              <div className="dropdown-section">
                <ul className="dropdown-submenu">
                  {item.children.map((child, i) => (
                    <li
                      key={i}
                      className="dropdown-submenu__item no-uppercase"
                      onClick={() => {
                        if (child.onClick) {
                          child.onClick();
                          setOpenIdx(null);
                        } else if (child.path) {
                          navigate(child.path);
                          setOpenIdx(null);
                        }
                      }}
                    >
                      {child.label}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default DropdownMenu;
